import { render, staticRenderFns } from "./cartComponent.vue?vue&type=template&id=060ab51c"
import script from "./cartComponent.vue?vue&type=script&lang=js"
export * from "./cartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports